import { z } from 'zod';

const QueryField = z.array(z.string().uuid().array()).nullish();
const queryStoreKeyEnum = z.enum([
  'policyIds',
  'organizationIds',
  'relatedOrganizationIds',
  'expenditurePurposeIds',
  'expenditureBudgetPurposeIds',
  'expenditureNatureIds',
  'expenditureItemNatureIds',
  'otherResponsibleOrganizationIds',
  'pinpointKeys',
]);

const queryStoreKey = queryStoreKeyEnum.enum;

export const QueryStoreQueryModel = z.object({
  [queryStoreKey.policyIds]: QueryField,
  [queryStoreKey.organizationIds]: QueryField,
  [queryStoreKey.relatedOrganizationIds]: QueryField,
  [queryStoreKey.expenditurePurposeIds]: QueryField,
  [queryStoreKey.expenditureBudgetPurposeIds]: QueryField,
  [queryStoreKey.expenditureNatureIds]: QueryField,
  [queryStoreKey.expenditureItemNatureIds]: QueryField,
  [queryStoreKey.otherResponsibleOrganizationIds]: QueryField,
  [queryStoreKey.pinpointKeys]: z.array(z.string().array()).nullish(),
});

const QueryLeafsField = z.array(z.string().uuid()).nullish();

export const QueryStoreQueryLeafsModel = z.object({
  [queryStoreKey.policyIds]: QueryLeafsField,
  [queryStoreKey.organizationIds]: QueryLeafsField,
  [queryStoreKey.relatedOrganizationIds]: QueryLeafsField,
  [queryStoreKey.expenditurePurposeIds]: QueryLeafsField,
  [queryStoreKey.expenditureBudgetPurposeIds]: QueryLeafsField,
  [queryStoreKey.expenditureNatureIds]: QueryLeafsField,
  [queryStoreKey.expenditureItemNatureIds]: QueryLeafsField,
  [queryStoreKey.otherResponsibleOrganizationIds]: QueryLeafsField,
  // /** 箇所指定 */
  [queryStoreKey.pinpointKeys]: z.array(z.string()).nullish(),
});

export const QueryStoreModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  query: QueryStoreQueryModel.nullish(),
  queryLeafs: QueryStoreQueryLeafsModel.nullish(),
});
